import GamesContainer from './games'

export default GamesContainer